import { CreateCampaignView, GrowthDashboardTopBarActions } from '@elva/ui';
import { useNavigate } from 'react-router-dom';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import {
  useSuggestedCampaignMutations,
  useSuggestedCampaigns,
} from '@/features/campaigns/hooks/useCampaigns';

/** Map create-UI service values → live `service_category` enums. */
const SERVICE_CATEGORY_MAP: Record<string, string> = {
  emergency: 'emergency',
  implants: 'implants',
  whitening: 'whitening',
  invisalign: 'orthodontics',
  veneers: 'general-dentistry',
  family: 'general-dentistry',
  sedation: 'general-dentistry',
  checkups: 'general-dentistry',
  other: 'general-dentistry',
  'general-dentistry': 'general-dentistry',
  orthodontics: 'orthodontics',
};

export function CreateCampaignPage() {
  const navigate = useNavigate();

  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } =
    useSuggestedCampaigns();
  const { dismiss, generate } = useSuggestedCampaignMutations();

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
    >
      <CreateCampaignView
        {...viewProps({
          items: data?.ccItems,
          loading: isFetching || generate.isPending || dismiss.isPending,
          onPreview: (suggestionId: number) => {
            const backendId = data?.idMap[suggestionId] ?? String(suggestionId);
            navigate(`/campaigns/create/preview/${backendId}`);
          },
          onDismiss: (suggestionId: number) => {
            const backendId = data?.idMap[suggestionId];
            if (backendId) dismiss.mutate(backendId);
          },
          onGenerateCustom: (input: {
            serviceCategory: string;
            monthlyBudgetCents: number;
            instructions?: string;
          }) => {
            generate.mutate({
              serviceCategory:
                SERVICE_CATEGORY_MAP[input.serviceCategory] ?? 'general-dentistry',
              monthlyBudgetCents: input.monthlyBudgetCents,
              ...(input.instructions ? { instructions: input.instructions } : {}),
            });
          },
        })}
      />
    </AsyncBoundary>
  );
}
